/** Check if we are running in the desktop app environment (Webapp only) */
export function isDesktopApp(): boolean {
  return typeof window !== "undefined" && typeof window.electron !== "undefined";
}
